import { HOME_PAGE } from "@/constants/app";
import {
  IBlog,
  IBlogFields,
  ILink,
  ILinkFields,
  IPage,
  IPageFields,
} from "@/types/generated/contentful";

export function generateCTAUrl(action: IBlog | IPage | ILink) {
  const actionType = action.sys.contentType.sys.id;
  const actionFields = action.fields as IBlogFields | IPageFields | ILinkFields;

  let url = "";
  switch (actionType) {
    case "blog":
      url = `/insights/${(actionFields as IBlogFields).slug}`;
      break;
    case "page":
      const pageFields = actionFields as IPageFields;
      url =
        pageFields.slug === HOME_PAGE.slug
          ? HOME_PAGE.route
          : `/${pageFields.slug}`;
      break;
    case "link":
      url = (action.fields as ILinkFields).url;
      break;
    default:
      url = "#";
      break;
  }

  return url;
}
